import { render, staticRenderFns } from "./Dratf.vue?vue&type=template&id=3165e68c&"
import script from "./Dratf.vue?vue&type=script&lang=js&"
export * from "./Dratf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports